import type { OpsTask } from '../types';

export const OPS_DEFAULT_BAR_DAYS = 7;

export function stripOpsDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

/** Timeline bar range; tasks need at least a due date. */
export function getOpsTaskSchedule(task: OpsTask): { start: Date; end: Date; inferredStart: boolean } | null {
  if (!task.dueDate) return null;
  const end = stripOpsDay(new Date(task.dueDate));
  let inferredStart = false;
  let start: Date;
  if (task.startDate) {
    start = stripOpsDay(new Date(task.startDate));
  } else {
    start = new Date(end);
    start.setDate(start.getDate() - (OPS_DEFAULT_BAR_DAYS - 1));
    inferredStart = true;
  }
  if (start.getTime() > end.getTime()) start = new Date(end);
  return { start, end, inferredStart };
}

/** When setting due from UI, ensure a start exists for the timeline. */
export function defaultOpsStartForDue(due: Date): Date {
  const end = stripOpsDay(due);
  const start = new Date(end);
  start.setDate(start.getDate() - (OPS_DEFAULT_BAR_DAYS - 1));
  return start;
}
